<template>
  <div>
    <TitlePage title="Conversazioni Chatbot AI"></TitlePage>

    <v-row class="mb-2 px-3">
      <v-spacer></v-spacer>
      <v-btn color="secondary" outlined :to="'/chatbot/settings'">
        <v-icon left>mdi-cog-outline</v-icon>
        Impostazioni
      </v-btn>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="conversations"
      :loading="loading"
      :server-items-length="total"
      :options.sync="options"
      class="elevation-1"
      style="cursor:pointer"
      @click:row="goToDetail"
    >
      <template v-slot:item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>
      <template v-slot:item.preview="{ item }">
        {{ firstUserMessage(item) }}
      </template>
      <template v-slot:item.msg_count="{ item }">
        {{ item.messages.length }}
      </template>
      <template v-slot:item.resolved="{ item }">
        <v-icon :color="item.resolved ? 'success' : 'warning'">
          {{ item.resolved ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}
        </v-icon>
      </template>
      <template v-slot:item.fallback_used="{ item }">
        <v-icon v-if="item.fallback_used" color="orange">mdi-account-alert-outline</v-icon>
        <span v-else>—</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TitlePage from '@/components/utils/TitlePage';
import { mapActions } from 'vuex';

export default {
  name: 'ChatbotIndex',
  components: { TitlePage },
  data() {
    return {
      conversations: [],
      total: 0,
      loading: false,
      options: { page: 1, itemsPerPage: 20 },
      headers: [
        { text: 'Data', value: 'created_at', width: 170 },
        { text: 'Prima domanda', value: 'preview', sortable: false },
        { text: 'Messaggi', value: 'msg_count', width: 100, sortable: false },
        { text: 'Risolto', value: 'resolved', width: 90, sortable: false },
        { text: 'Assistenza', value: 'fallback_used', width: 110, sortable: false }
      ]
    };
  },
  watch: {
    options: { handler() { this.load(); }, deep: true }
  },
  mounted() { this.load(); },
  methods: {
    ...mapActions({ fetchConversations: 'chatbot/index' }),
    async load() {
      this.loading = true;
      try {
        const { page, itemsPerPage } = this.options;
        const result = await this.fetchConversations({ page, limit: itemsPerPage });
        this.conversations = result.conversations;
        this.total = result.count;
      } finally {
        this.loading = false;
      }
    },
    goToDetail(item) {
      this.$router.push(`/chatbot/${item._id}`);
    },
    firstUserMessage(item) {
      const m = item.messages.find(m => m.role === 'user');
      if (!m) return '—';
      return m.content.length > 90 ? m.content.slice(0, 90) + '…' : m.content;
    },
    formatDate(d) {
      return d ? new Date(d).toLocaleString('it-IT') : '—';
    }
  }
};
</script>
